import styled, { css } from 'styled-components/macro';

import { colors } from '../../styles/vars';

const iconButtonActivePath = css`
  opacity: 1;
`;

const iconButtonActiveDot = css`
  &::after {
    content: '';
    position: absolute;
    bottom: 1px;
    right: 3px;
    width: 8px;
    height: 8px;
    border: 1px solid #fff;
    border-radius: 50%;
    background-color: #fff;
  }
`;

const IconButton = styled.button.attrs({
  type: 'button',
})`
  position: relative;
  margin-bottom: 10px;
  background-color: transparent;
  border-style: none;
  cursor: pointer;

  ${props => (props.active
    ? `color: ${colors['warm-grey-two']};` && iconButtonActiveDot
    : 'color: #1a1616;'
  )}

  path,
  circle {
    fill: #fff;
    opacity: 0.4;
    transition: opacity 0.15s ease-out;
    ${props => props.active && iconButtonActivePath}
  }

  &:hover path,
  &:hover circle {
    ${iconButtonActivePath}
  }
`;

export default IconButton;
